import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import BeforeAfter from './components/BeforeAfter';
import Process from './components/Process';
import Brands from './components/Brands';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { FloatingWhatsApp, ScrollTop, CookieBanner } from './components/Floating';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <BeforeAfter />
      <Process />
      <Brands />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
      <ScrollTop />
      <CookieBanner />
    </div>
  );
}

export default App;
